import { useArtGeneratorViewController } from 'modules/art/controllers';
import { CropPhotoView } from './CropPhotoView';
import { SelectVariantView2 } from './SelectVariantView2';
import { UploadPhotoView2 } from './UploadPhotoView2';
import { StepModeValue } from 'modules/art/types';

export const CreateArtView2 = () => {
  const { Upload, Crop, ChooseVariant } = StepModeValue;

  const {
    step,
    image,
    isGenerateLoading,
    setStep,
    uploadImage,
    uploadImage2,
    saveCrop2,
    generationParams,
    beGeneration,
  } = useArtGeneratorViewController(Upload);

  return (
    <>
      {step === Upload && (
        <UploadPhotoView2
          initForm={generationParams}
          uploadImage={data => uploadImage2(data, () => setStep(Crop))}
        />
      )}

      {step === Crop && (
        <CropPhotoView
          image={image}
          goBack={() => setStep(Upload)}
          uploadImage={uploadImage}
          saveCrop={saveCrop2}
        />
      )}

      {step === ChooseVariant && (
        <SelectVariantView2
          isGenerateLoading={isGenerateLoading}
          beGeneration={beGeneration}
          goBack={() => setStep(Crop)}
          goFurther={() => {}}
        />
      )}
    </>
  );
};
